import React from "react";
import styled from "@emotion/styled";

const Field = styled.div`
  grid-column: ${props => (props.full ? "1 / -1" : "auto")};
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Label = styled.label`
  font-size: 0.82rem;
  font-weight: 600;
  color: #46586a;
  margin-bottom: 6px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  font-size: 1rem;
  color: #1f2d3d;
  background: #fff;
  border: 1px solid #dfe3e8;
  border-radius: 10px;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }

  &::placeholder {
    color: #aab4bf;
  }

  &:focus {
    outline: none;
    border-color: #01bf71;
    box-shadow: 0 0 0 3px rgba(1, 191, 113, 0.15);
  }
`;

const FormField = ({ label, type, name, placeholder, pattern, required, full }) => {
  return (
    <Field full={full}>
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        pattern={pattern}
        required={required}
      />
    </Field>
  );
};

export default FormField;
